"use client";

import { useState } from "react";
import { Mail, Phone, MapPin, Send, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { FormProvider } from "@/integrations/forms/FormProvider";
export default function HeroCallToAction() {
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const {
    ref: formRef,
    isVisible: formVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const scrollToForm = () => {
    const formElement = document.querySelector("#contact-form");
    formElement?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  };
  return <section id="hero-calltoaction" className="relative min-h-screen flex flex-col">
      {}
      <div className="fixed inset-0 z-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1529869/img/wedding_dance_floor_bokeh_lights.png)] bg-cover bg-center bg-no-repeat">
        <div className="absolute inset-0 bg-dark-background/70"></div>
      </div>

      {}
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 py-20">
        <div ref={heroRef} className={`max-w-4xl mx-auto text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-foreground-dark mb-6">
            Make Your Special Day Come to Life
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl text-foreground-dark/90 mb-8 max-w-3xl mx-auto">
            Denver's premier wedding DJ and AV specialist with years of experience creating unforgettable celebrations tailored to your vision.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" onClick={scrollToForm} className="text-lg px-8 py-6 hover:-translate-y-0.5 hover:shadow-strong active:translate-y-0 transition-all duration-300">
              Let's Talk About Your Event
            </Button>
          </div>
        </div>
      </div>

      {}
      <Button variant="ghost" size="icon" onClick={scrollToForm} className="relative z-10 mb-8 mx-auto animate-bounce hover:scale-110 transition-transform duration-300 rounded-full" aria-label="Scroll to contact form">
        <ChevronDown className="size-8 text-foreground-dark" />
      </Button>

      {}
      <div className="relative z-10 bg-light-background py-16 px-4 sm:px-6 lg:px-8">
        <div ref={formRef} id="contact-form" className={`max-w-4xl mx-auto transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${formVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="text-center mb-12">
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-foreground-light mb-4">
              Let's Create Something Unforgettable
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Tell us about your event and we'll craft the perfect audio and lighting experience for your special day.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="flex flex-col items-center text-center p-6 rounded-lg bg-muted-light-background">
              <Phone className="size-8 text-primary mb-3" />
              <h3 className="font-display font-semibold text-lg mb-2">Phone</h3>
              <p className="text-muted-foreground">(303) 555-1234</p>
            </div>
            <div className="flex flex-col items-center text-center p-6 rounded-lg bg-muted-light-background">
              <Mail className="size-8 text-primary mb-3" />
              <h3 className="font-display font-semibold text-lg mb-2">Email</h3>
              <p className="text-muted-foreground">info@jordanebner.com</p>
            </div>
            <div className="flex flex-col items-center text-center p-6 rounded-lg bg-muted-light-background">
              <MapPin className="size-8 text-primary mb-3" />
              <h3 className="font-display font-semibold text-lg mb-2">Location</h3>
              <p className="text-muted-foreground">Denver, CO</p>
            </div>
          </div>

          <div className="card p-8 md:p-10">
            <FormProvider formId="contact-form" fields={[{
            name: "name",
            type: "text",
            label: "Your Name",
            required: true,
            placeholder: "John Doe"
          }, {
            name: "email",
            type: "email",
            label: "Email Address",
            required: true,
            placeholder: "john@example.com"
          }, {
            name: "phone",
            type: "tel",
            label: "Phone Number",
            required: true,
            placeholder: "(303) 555-1234"
          }, {
            name: "eventDate",
            type: "date",
            label: "Event Date",
            required: true
          }, {
            name: "message",
            type: "textarea",
            label: "Tell Us About Your Event",
            required: true,
            placeholder: "Share your vision, preferred music styles, special requests, or any questions you have...",
            rows: 6
          }]} submitButtonText="Send Message" submitButtonIcon={<Send />} onSubmitSuccess={() => {
            console.log("Form submitted successfully");
          }} />
          </div>
        </div>
      </div>
    </section>;
}